import React from 'react';
import Modal from 'react-modal';
import {connect} from "react-redux";
import PropTypes from 'prop-types';

import {NotificationManager} from "react-notifications";

import * as AdminActions from "../../../../actions/admin"
import UserFieldDataType from "../../../../utils/enums/UserFieldDataTypeEnum";
import UserFieldElement from '../../../reusable/UserFieldElement';

class ExportDialog extends React.Component {

    static propTypes = {
        onClose: PropTypes.func.isRequired,
        onSuccess: PropTypes.func,
        exportType: PropTypes.string,
    };

    static defaultProps = {
        onSuccess: null,
        exportType: 'races',
    };

    constructor(props) {
        super(props);
        this.state = {
            sectionFrom: '',
            sectionTo: '69',
            clubFrom: '',
            clubTo: '299',
            exportOption: props.exportType,
            rangeStats: false,
        }
    }

    fields = [];
    render() {
        return <div>
            <Modal
                isOpen={true}
                onRequestClose={() => {this.props.onClose()}}
                style={{
                    overlay: {
                        zIndex: 10,
                    },
                    content : {
                        height: '500px',
                        width: '500px',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                    }
                }}
            >
                <div className="dialog">
                    <div className="dialog-title">Eksporter til foreninger</div>

                    <div className="dialog-body">
                        <div className="dialog-inner-body">
                            <table className="fields">
                                <tbody>
                                    <tr>
                                        <td><label htmlFor="sectionFrom">Fra sektion</label></td>
                                        <td>
                                            <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field50" containerClassName="display-inline-block"
                                                              name="sectionFrom" id="sectionFrom" maxLength="2" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY, value: "[0-9]{2}"}]} value={this.state.sectionFrom}
                                                              autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                              onChange={this.onStandardFieldChange}
                                                              ref={instance => { this.fields[0] = instance; }}
                                            />
                                        </td>
                                        <td><label htmlFor="sectionTo">Til sektion</label></td>
                                        <td>
                                            <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field50" containerClassName="display-inline-block"
                                                              name="sectionTo" id="sectionTo" maxLength="2" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY, value: "[0-9]{2}"}]} value={this.state.sectionTo}
                                                              autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                              onChange={this.onStandardFieldChange}
                                                              ref={instance => { this.fields[1] = instance; }}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><label htmlFor="clubFrom">Fra forening</label></td>
                                        <td>
                                            <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field50" containerClassName="display-inline-block"
                                                              name="clubFrom" id="clubFrom" maxLength="3" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY, value: "[0-9]{3}"}]} value={this.state.clubFrom}
                                                              autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                              onChange={this.onStandardFieldChange}
                                                              onBlur={() => {
                                                                  this.fields[2].setState({focused: false, visited: true});
                                                                  if (/^[0-9]{1,2}$/.test(this.state.clubFrom)) this.setState({clubFrom: this.state.clubFrom.padStart(3, '0'), clubTo: this.state.clubTo === '' ? this.state.clubFrom.padStart(3, '0') : this.state.clubTo});
                                                                  else if (/^[0-9]{3}$/.test(this.state.clubFrom) && this.state.clubTo === '') this.setState({clubTo: this.state.clubFrom});
                                                              }}
                                                              ref={instance => { this.fields[2] = instance; }}
                                            />
                                        </td>
                                        <td><label htmlFor="clubTo">Til forening</label></td>
                                        <td>
                                            <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field50" containerClassName="display-inline-block"
                                                              name="clubTo" id="clubTo" maxLength="3" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY, value: "[0-9]{3}"}]} value={this.state.clubTo}
                                                              autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                              onChange={this.onStandardFieldChange}
                                                              onBlur={() => {
                                                                  this.fields[3].setState({focused: false, visited: true});
                                                                  if (/^[0-9]{1,2}$/.test(this.state.clubTo)) this.setState({clubTo: this.state.clubTo.padStart(3, '0')});
                                                              }}
                                                              ref={instance => { this.fields[3] = instance; }}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan={4} className="large-vertical-spacing">
                                            <div className="small-vertical-spacing">
                                                <input type="radio" id="optRaces" name="expOption" checked={this.state.exportOption === 'races'} onClick={() => this.setState({exportOption: 'races'})}/> <label htmlFor="optRaces">Eksporter sæsonstart/justeringer</label>
                                            </div>
                                            <div className="small-vertical-spacing">
                                                <input type="radio" id="optDdbStat" name="expOption" checked={this.state.exportOption === 'ddb-stat'} onClick={() => this.setState({exportOption: 'ddb-stat'})}/> <label htmlFor="optDdbStat">Eksporter DDB-statistik</label>
                                            </div>
                                            <div className="small-vertical-spacing">
                                                <input type="radio" id="optSectionStat" name="expOption" checked={this.state.exportOption === 'section-stat'} onClick={() => this.setState({exportOption: 'section-stat'})}/> <label htmlFor="optSectionStat">Eksporter sektionsstatistik</label>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan={4}>
                                            <div className="small-vertical-spacing">
                                                <input type="checkbox" id="rangeStats" name="rangeStats" disabled={this.state.exportOption !== 'ddb-stat' && this.state.exportOption !== 'section-stat'} checked={this.state.rangeStats} onClick={() => this.setState({rangeStats: !this.state.rangeStats})}/> <label htmlFor="rangeStats" className={this.state.exportOption !== 'ddb-stat' && this.state.exportOption !== 'section-stat' ? 'disabled' : ''}>Træk statistik områdevist</label>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="actions-row">
                        <button className="btn-primary" onClick={this.onExport}>Eksporter</button>
                        <button className="btn-secondary float-right" onClick={() => {this.props.onClose()}}>Annuller</button>
                    </div>
                </div>
            </Modal>
        </div>
    }

    onExport = () => {
        if (this.allInputValid()) {
            this.props.dispatch(AdminActions.exportRaceData(Object.assign({
                sectionFrom: this.state.sectionFrom === '' ? null : this.state.sectionFrom,
                sectionTo: this.state.sectionTo === '' ? null : this.state.sectionTo,
                clubFrom: this.state.clubFrom === '' ? null : this.state.clubFrom,
                clubTo: this.state.clubTo === '' ? null : this.state.clubTo,
            }, this.state.exportOption === 'ddb-stat' || this.state.exportOption === 'section-stat' ? {rangeStats: this.state.rangeStats} : {}), this.state.exportOption, (status) => {
                NotificationManager.success("Eksportfiler er genereret til de valgte foreninger.", "Eksport", 4000);
                status.messages.forEach(msg => {NotificationManager.warning(msg, 'Advarsel', 0);});
                this.props.onClose();
            }))
        } else {
            this.fields.forEach((field) => {
                field.setState({visited: true});
            });
        }
    };

    onStandardFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.value});
    };

    allInputValid = () => {
        let result = true;
        this.fields.forEach((field, ix) => {
            if (field && !field.isValid()) result = false;
        });
        return result;
    };
}

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps)(ExportDialog);


// WEBPACK FOOTER //
// ./src/client/src/components/pages/home/dialogs/ExportDialog.js